import { render, staticRenderFns } from "./myOrdersPage.vue?vue&type=template&id=a2a7d0f4&scoped=true&"
import script from "./myOrdersPage.vue?vue&type=script&lang=ts&"
export * from "./myOrdersPage.vue?vue&type=script&lang=ts&"
import style0 from "./myOrdersPage.vue?vue&type=style&index=0&id=a2a7d0f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a7d0f4",
  null
  
)

export default component.exports